import { createSlice } from '@reduxjs/toolkit';

const token = localStorage.getItem('token');

export const authSlice = createSlice({
    name: 'auth',
    initialState: {
        user:  null, // Parse user from localStorage
        isAuthenticated: !!token, // Boolean based on token existence
        token: token || null,
    },
    reducers: {
        setUser: (state, action) => {
            const { user, token } = action.payload;
            state.user = user;
            state.token = token;
            state.isAuthenticated = true;
        },
        logout: (state) => {
            state.user = null;
            state.isAuthenticated = false;
            state.token = null;

            // Remove from localStorage
            localStorage.removeItem('userData');
            localStorage.removeItem('tokenData');
        },
    },
});

export const { setUser, logout } = authSlice.actions;

export default authSlice.reducer;
